/**
 * customsirge_pdp_buy_box.js — pair qty, multi-pair variant rows,
 * "Chart" text button on the Profile variant picker.
 */
(function () {
  var PAIR_SYNC_DELAY = 1200;

  function getPairConfigsRoot() {
    return document.querySelector("[data-customsirge-pair-configs]");
  }

  function getPrimaryPairGroup() {
    return document.querySelector('[data-customsirge-pair-group="1"]');
  }

  function slugify(text) {
    return (text || "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-|-$)/g, "");
  }

  function getOptionLabels(group) {
    var labels = [];
    group.querySelectorAll(".selector-wrapper label").forEach(function (label) {
      var name = (label.textContent || "").trim();
      if (name) labels.push(name);
    });
    return labels;
  }

  function getSelectedValues(group) {
    var values = {};
    group.querySelectorAll(".selector-wrapper").forEach(function (wrapper) {
      var label = wrapper.querySelector("label");
      var optionName = label ? (label.textContent || "").trim() : "";
      if (!optionName) return;

      var checked = wrapper.querySelector('input[type="radio"]:checked');
      if (checked) {
        values[optionName] = checked.value;
        return;
      }

      var select = wrapper.querySelector("select");
      if (select && select.value) {
        values[optionName] = select.value;
      }
    });
    return values;
  }

  function buildPairClone(pairNumber, sourceGroup) {
    var clone = document.createElement("div");
    clone.className = "customsirge-pdp-buy__pair-group";
    clone.setAttribute("data-customsirge-pair-group", String(pairNumber));
    clone.setAttribute("data-customsirge-pair-clone", "true");

    var heading = document.createElement("p");
    heading.className = "customsirge-pdp-buy__pair-label";
    heading.textContent = "Pair " + pairNumber;
    clone.appendChild(heading);

    var body = document.createElement("div");
    body.className = "flex flex-col gap-4";

    sourceGroup
      .querySelectorAll(".selector-wrapper")
      .forEach(function (wrapper) {
        var clonedWrapper = wrapper.cloneNode(true);
        var label = clonedWrapper.querySelector("label");
        var optionName = label ? (label.textContent || "").trim() : "Option";
        var optionSlug = slugify(optionName);

        // The chart button belongs to the primary picker only — never to a pair clone.
        clonedWrapper
          .querySelectorAll(".profile-chart-link")
          .forEach(function (link) {
            link.remove();
          });

        clonedWrapper
          .querySelectorAll('input[type="radio"]')
          .forEach(function (input, index) {
            var newId = "pair-" + pairNumber + "-" + optionSlug + "-" + index;
            input.id = newId;
            input.name = "pair-" + pairNumber + "-" + optionSlug + "-radio";
            input.removeAttribute("data-index");
            input.addEventListener("change", function () {
              syncPairProperties();
            });
          });

        clonedWrapper
          .querySelectorAll("label[for]")
          .forEach(function (labelEl, index) {
            var input = clonedWrapper.querySelectorAll('input[type="radio"]')[
              index
            ];
            if (input) labelEl.setAttribute("for", input.id);
          });

        var select = clonedWrapper.querySelector("select");
        if (select) {
          select.id = "pair-" + pairNumber + "-" + optionSlug + "-select";
          select.name = "";
          select.removeAttribute("data-index");
          select.addEventListener("change", function () {
            syncPairProperties();
          });
        }

        body.appendChild(clonedWrapper);
      });

    clone.appendChild(body);
    return clone;
  }

  function ensurePairClones() {
    var configsRoot = getPairConfigsRoot();
    var primaryGroup = getPrimaryPairGroup();
    if (!configsRoot || !primaryGroup) return;

    var rendered =
      primaryGroup.querySelectorAll(".selector-wrapper").length > 0;
    if (!rendered) return;

    [2, 3].forEach(function (pairNumber) {
      if (
        !configsRoot.querySelector(
          '[data-customsirge-pair-group="' + pairNumber + '"]'
        )
      ) {
        configsRoot.appendChild(buildPairClone(pairNumber, primaryGroup));
      }
    });
  }

  function removePairPropertyInputs() {
    document
      .querySelectorAll("[data-customsirge-pair-property]")
      .forEach(function (input) {
        input.remove();
      });
  }

  function syncPairProperties() {
    var form = document.querySelector("#add-to-cart");
    var configsRoot = getPairConfigsRoot();
    if (!form || !configsRoot) return;

    removePairPropertyInputs();

    configsRoot
      .querySelectorAll("[data-customsirge-pair-group]")
      .forEach(function (group) {
        var pairNumber = group.getAttribute("data-customsirge-pair-group");
        if (!pairNumber || group.hidden) return;

        var values = getSelectedValues(group);
        Object.keys(values).forEach(function (optionName) {
          var input = document.createElement("input");
          input.type = "hidden";
          input.name = "properties[Pair " + pairNumber + " " + optionName + "]";
          input.value = values[optionName];
          input.setAttribute("data-customsirge-pair-property", "true");
          form.appendChild(input);
        });
      });
  }

  function setActivePairQty(qty) {
    var pairs = document.querySelector("[data-customsirge-buy-pairs]");
    var configsRoot = getPairConfigsRoot();
    if (!pairs) return;

    pairs.querySelectorAll("[data-pair-qty]").forEach(function (btn) {
      var btnQty = parseInt(btn.getAttribute("data-pair-qty"), 10) || 1;
      var isActive = btnQty === qty;
      btn.classList.toggle("is-active", isActive);
      btn.setAttribute("aria-pressed", isActive ? "true" : "false");
    });

    if (configsRoot) {
      configsRoot
        .querySelectorAll("[data-customsirge-pair-group]")
        .forEach(function (group) {
          var pairNumber =
            parseInt(group.getAttribute("data-customsirge-pair-group"), 10) ||
            1;
          var show = pairNumber <= qty;
          group.hidden = !show;
          group.setAttribute("aria-hidden", show ? "false" : "true");
        });
    }

    syncPairProperties();
  }

  function initPairQty() {
    var pairs = document.querySelector("[data-customsirge-buy-pairs]");
    if (!pairs) return;

    var qtyInput = document.querySelector(
      "#add-to-cart [data-qtt-id], #add-to-cart #Quantity"
    );

    pairs.querySelectorAll("[data-pair-qty]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var qty = parseInt(btn.getAttribute("data-pair-qty"), 10) || 1;
        if (qtyInput) {
          qtyInput.value = qty;
          qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
        }
        setActivePairQty(qty);
      });
    });

    setTimeout(function () {
      ensurePairClones();
      setActivePairQty(1);

      var primaryGroup = getPrimaryPairGroup();
      if (primaryGroup) {
        primaryGroup.addEventListener("change", syncPairProperties);
      }

      var form = document.querySelector("#add-to-cart");
      if (form) {
        form.addEventListener("submit", syncPairProperties);
      }
    }, PAIR_SYNC_DELAY);
  }

  // ---- "See Profile Chart" link: keep it inline with the Profile picker label ----------------
  // The link is rendered STATICALLY in product-hero.liquid (gated on the Profile chart image), so it
  // is always visible. This just relocates that existing element next to the runtime-built "PROFILE"
  // label once the compiled bundle renders it (and re-does so if the bundle rebuilds the picker).
  // No building/detection — just a move, anchored on the reliable .type-profile class the bundle
  // stamps. If the Profile picker never appears, the link simply stays where Liquid placed it.
  function initProfileChartInline() {
    var link = document.querySelector(".customsirge-pdp-hero__buy .profile-chart-link");
    if (!link) return; // image not set -> no link to place

    var buyBox = document.querySelector(".customsirge-pdp-hero__buy");
    if (!buyBox) return;

    function profileWrapper() {
      var wrap = buyBox.querySelector(".selector-wrapper.type-profile");
      if (wrap) return wrap;
      // Fallback: match by the option label text in case the option isn't slugged to "profile".
      var wraps = buyBox.querySelectorAll(".selector-wrapper");
      for (var i = 0; i < wraps.length; i++) {
        var l = wraps[i].querySelector("label");
        if (l && !l.closest(".radio-selector") && /profile/i.test(l.textContent || "")) return wraps[i];
      }
      return null;
    }

    function place() {
      var wrap = profileWrapper();
      if (!wrap) return; // picker not built yet -> link stays in its static spot (still visible)
      var labels = wrap.querySelectorAll("label");
      var label = null;
      for (var i = 0; i < labels.length; i++) {
        if (!labels[i].closest(".radio-selector")) {
          label = labels[i];
          break;
        }
      }
      if (!label) return;

      var row = label.parentElement;
      if (!row || !row.classList.contains("customsirge-pdp-buy__label-row")) {
        row = document.createElement("div");
        row.className = "flex items-center customsirge-pdp-buy__label-row";
        label.parentElement.insertBefore(row, label);
        row.appendChild(label);
      }
      if (link.parentElement !== row) row.appendChild(link); // (re)place inline
    }

    place();
    // The bundle builds the picker async and rebuilds it on every variant change (which detaches the
    // moved link), so re-place for the life of the page. place() is idempotent -> cheap, loop-free.
    if (typeof MutationObserver === "function") {
      new MutationObserver(place).observe(buyBox, { childList: true, subtree: true });
    }
  }

  // ---- Mandatory size selection --------------------------------------------------------------
  // The variant engine + size dropdown are compiled into product-bundle.min.js (no build step in
  // repo), and that bundle continuously auto-selects the first size. We can't stop it, so we work
  // around it entirely from here: paint a "Select a size" placeholder over the auto-selected value
  // (via a CSS class on the .type-size wrapper), relabel the Add-to-Cart button to "Select a size",
  // and block the form submit until the shopper makes a REAL pick. Covers hero + sticky ATC.
  function initSizeGate() {
    var HINT = "Select a size";
    var UNSET = "customsirge_size-unset";
    var SIZE_WRAP = ".selector-wrapper.type-size";

    var form = document.querySelector("#add-to-cart");
    if (!form) return;

    var buyBox = document.querySelector(".customsirge-pdp-hero__buy");
    var stickyBar = document.querySelector("[data-customsirge-sticky-atc]");

    // Kaching bundles mode: stand down entirely. The app owns variant selection and its own
    // add-to-cart flow, and gating the theme form fought it — the gate's submit block also stopped
    // the app from adding its bundle items. So no "Select a size" relabel, no unset styling, and no
    // submit interception here: the add-to-cart button keeps the theme's default behaviour.
    if (
      (buyBox && buyBox.hasAttribute("data-customsirge-bundle-mode")) ||
      document.querySelector("#product-variants.customsirge-native-pickers-hidden")
    ) {
      return;
    }

    var armed = false; // becomes true once a real size selector exists on this product
    var sizeChosen = false;
    var observers = [];

    function sizeWrappers() {
      return Array.prototype.slice.call(document.querySelectorAll(SIZE_WRAP));
    }
    function atcButtons() {
      var btns = [];
      var heroBtn = form.querySelector(
        "#product-add-to-cart, button[name='add']"
      );
      if (heroBtn) btns.push(heroBtn);
      var stickyBtn = document.querySelector(
        "[data-customsirge-sticky-submit]"
      );
      if (stickyBtn) btns.push(stickyBtn);
      return btns;
    }
    function setHint(btn) {
      if ((btn.textContent || "").trim() === HINT) return; // already hinted
      if (btn.dataset.csOrigLabel === undefined)
        btn.dataset.csOrigLabel = btn.textContent;
      btn.textContent = HINT;
    }
    function restoreHint(btn) {
      if (btn.dataset.csOrigLabel !== undefined) {
        btn.textContent = btn.dataset.csOrigLabel;
        delete btn.dataset.csOrigLabel;
      }
    }

    // Re-assert the unchosen state. Cheap + idempotent, so it can run on every DOM mutation: the
    // bundle rebuilds the styled control and clones the ATC button on any variant change.
    function applyUnsetState() {
      if (sizeChosen) return;
      var wraps = sizeWrappers();
      if (!wraps.length) return; // no size option on this product (e.g. single-variant) -> never arm
      armed = true;
      wraps.forEach(function (w) {
        w.classList.add(UNSET);
      });
      atcButtons().forEach(setHint);
    }

    function markSizeChosen() {
      if (sizeChosen) return;
      sizeChosen = true;
      sizeWrappers().forEach(function (w) {
        w.classList.remove(UNSET);
      });
      atcButtons().forEach(restoreHint);
      observers.forEach(function (o) {
        o.disconnect();
      });
      observers = [];
    }

    function watch(node) {
      if (!node || typeof MutationObserver !== "function") return;
      var mo = new MutationObserver(applyUnsetState);
      mo.observe(node, { childList: true, subtree: true });
      observers.push(mo);
    }

    function openSizePicker() {
      var stickyVisible =
        stickyBar &&
        stickyBar.getAttribute("aria-hidden") !== "true" &&
        (stickyBar.classList.contains("customsirge-sticky-atc--visible") ||
          !stickyBar.hasAttribute("hidden"));
      var target = null;
      if (stickyVisible)
        target = stickyBar.querySelector(SIZE_WRAP + " .styled-select-button");
      if (!target && buyBox) {
        var heroWrap = buyBox.querySelector(SIZE_WRAP);
        if (heroWrap) {
          heroWrap.scrollIntoView({ behavior: "smooth", block: "center" });
          target = heroWrap.querySelector(".styled-select-button");
        }
      }
      if (target) {
        try {
          target.click();
        } catch (err) {}
      }
    }

    // Persistent enforcement until the shopper picks (or, on products without a size, never arms).
    watch(buyBox);
    watch(stickyBar);

    // Intent signal 1 — a real user pointer pick of a size option (hero + sticky both use .type-size
    // + .styled-select-option). Programmatic selection never clicks an option, so no false positives.
    // CAPTURE phase: StyledSelect's own click handler dispatches a change that synchronously rebuilds
    // (repopulates) the options, detaching the clicked node — so we must read it BEFORE that runs.
    document.addEventListener(
      "click",
      function (e) {
        if (sizeChosen) return;
        var opt =
          e.target && e.target.closest
            ? e.target.closest(".styled-select-option")
            : null;
        if (opt && opt.closest(SIZE_WRAP)) markSizeChosen();
      },
      true
    );
    // Intent signal 2 — native <select> fallback / keyboard: only a TRUSTED change counts (rejects
    // every change the bundle dispatches programmatically).
    document.addEventListener("change", function (e) {
      if (sizeChosen || !e.isTrusted) return;
      var t = e.target;
      if (
        t &&
        t.matches &&
        t.matches(SIZE_WRAP + " select") &&
        (t.value || "") !== ""
      ) {
        markSizeChosen();
        return;
      }
      // Intent signal 3 — Kaching bundles mode: the native size picker is hidden, so a real pick on
      // the Kaching size selector is what unblocks the add-to-cart. (Kaching stamps its size <select>
      // with both classes and data-name="Size".)
      if (
        t &&
        t.matches &&
        t.matches(".kaching-bundles__bar-variant-select.kaching-bundles-option")
      ) {
        var kName = (t.getAttribute("data-name") || "").toLowerCase();
        var kVal = t.value || t.getAttribute("data-value") || "";
        if ((kName === "" || kName === "size") && kVal !== "") markSizeChosen();
      }
    });

    // Submit guard — blocks the native /cart/add POST (and, transitively, the sticky button, which
    // proxies a .click() to the hero button). Bound to the FORM because the bundle clones the button.
    form.addEventListener(
      "submit",
      function (e) {
        if (!armed || sizeChosen) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        applyUnsetState();
        openSizePicker();
      },
      true
    );

    // Restored-from-bfcache with no size chosen -> re-assert the placeholder + hint.
    window.addEventListener("pageshow", applyUnsetState);

    applyUnsetState(); // in case the size UI is already present
  }

  // Dynamic buy-box price (customsirge-pdp-buy__price-main). Rule (per merchant):
  //   • If the Kaching bundles bar is present, MIRROR the selected bundle's price
  //     (.kaching-bundles__bar--selected .kaching-bundles__bar-price) — it already reflects
  //     variant + quantity + bundle discount.
  //   • Otherwise, show the selected variant's UNIT price × the chosen quantity (line total),
  //     scaling the compare-at / "You Save" figures too.
  // The value is re-asserted through a MutationObserver so it wins over productScript.js, which also
  // writes [data-price] on variant change (with the un-multiplied unit price).
  function initBuyPrice() {
    var row = document.querySelector("[data-customsirge-buy-price]");
    if (!row) return;
    var amountEl = row.querySelector("[data-price]");
    if (!amountEl) return;

    var compareWrap = row.querySelector("[data-compare]");
    var compareS = compareWrap ? compareWrap.querySelector("s") : null;
    var savingsWrap = row.querySelector(".customsirge-pdp-buy__savings");
    var savedAmountEl = savingsWrap
      ? savingsWrap.querySelector(".saved-amount")
      : null;

    var priceMap = {};
    var mapEl = document.querySelector("[data-customsirge-price-map]");
    if (mapEl) {
      try {
        priceMap = JSON.parse(mapEl.textContent).variants || {};
      } catch (e) {
        priceMap = {};
      }
    }

    function money(cents) {
      if (typeof window.formatMoney === "function") {
        return window.formatMoney(cents, window.money_format);
      }
      return "$" + (cents / 100).toFixed(2);
    }
    function kachingTotal() {
      // Price lives in the CURRENTLY-selected bundle bar. The --selected class moves between bars
      // as the shopper switches bundles, so always re-query the selected bar's price element.
      var el = document.querySelector(
        ".kaching-bundles__bar--selected .kaching-bundles__bar-price"
      );
      return el ? (el.textContent || "").trim() : "";
    }
    function kachingRoot() {
      // Outermost kaching-bundles* ancestor of a bar, so one observer covers all bars.
      var bar = document.querySelector('[class*="kaching-bundles__bar"]');
      if (!bar) return null;
      var root = bar;
      var p = bar.parentElement;
      while (p && typeof p.className === "string" && p.className.indexOf("kaching-bundles") !== -1) {
        root = p;
        p = p.parentElement;
      }
      return root;
    }
    function variantId() {
      var el = document.querySelector(
        '#add-to-cart [name="id"], #product-selectors[name="id"], #product-selectors'
      );
      return el ? el.value : null;
    }
    function qtyVal() {
      var el = document.querySelector(
        '#add-to-cart [name="quantity"], #add-to-cart #Quantity, #add-to-cart [data-qtt-id]'
      );
      var n = el ? parseInt(el.value, 10) : 1;
      return isNaN(n) || n < 1 ? 1 : n;
    }
    function unitFromAttr() {
      var a = parseInt(amountEl.getAttribute("data-price"), 10);
      return isNaN(a) ? null : a;
    }

    function compute() {
      var kt = kachingTotal();
      if (kt) {
        // Kaching present → mirror its total; hide the per-unit compare/savings (they don't
        // apply to a bundle total and Kaching surfaces its own savings).
        return { price: kt, showCompare: false, showSavings: false };
      }
      var entry = priceMap[variantId()];
      var unit = entry ? entry[0] : unitFromAttr();
      if (unit == null) return null;
      var qty = qtyVal();
      var total = unit * qty;
      var cmp = entry ? entry[1] : 0;
      var onSale = cmp && cmp > unit;
      var compareTotal = onSale ? cmp * qty : 0;
      return {
        price: money(total),
        showCompare: !!(onSale && compareS),
        compare: onSale ? money(compareTotal) : "",
        showSavings: !!(onSale && savedAmountEl),
        saved: onSale ? money(compareTotal - total) : "",
      };
    }

    var desired = null;
    function apply() {
      if (!desired) return;
      if (amountEl.textContent.trim() !== desired.price) {
        amountEl.textContent = desired.price;
      }
      if (compareWrap) {
        compareWrap.style.display = desired.showCompare ? "" : "none";
        if (compareS && desired.showCompare && compareS.textContent.trim() !== desired.compare) {
          compareS.textContent = desired.compare;
        }
      }
      if (savingsWrap) {
        savingsWrap.style.display = desired.showSavings ? "" : "none";
        if (savedAmountEl && desired.showSavings && savedAmountEl.textContent.trim() !== desired.saved) {
          savedAmountEl.textContent = desired.saved;
        }
      }
    }
    function recompute() {
      var next = compute();
      if (next) {
        desired = next;
        apply();
      }
    }

    // Re-assert our value if anything (e.g. productScript.js) rewrites the row's text.
    // Diff-guarded so our own writes don't loop.
    new MutationObserver(apply).observe(row, {
      childList: true,
      characterData: true,
      subtree: true,
    });

    // React to native quantity / variant / option changes (defer so productScript runs first).
    function deferred() {
      setTimeout(recompute, 0);
    }
    document.addEventListener("change", function (e) {
      var t = e.target;
      if (!t || !t.matches) return;
      if (
        t.matches('[name="quantity"], #Quantity, [data-qtt-id]') ||
        t.matches('#product-selectors, [name="id"]') ||
        t.matches(".single-option-selector__radio, .selector-wrapper select, .selector-wrapper input")
      ) {
        deferred();
      }
    });
    document.addEventListener("input", function (e) {
      if (e.target && e.target.matches && e.target.matches('[name="quantity"], #Quantity, [data-qtt-id]')) {
        deferred();
      }
    });
    document.addEventListener("click", function (e) {
      if (e.target && e.target.closest && e.target.closest(".qty-btn, .js-qty-update")) {
        deferred();
      }
    });

    // Observe the whole Kaching widget: recompute when the --selected bar changes (a class
    // mutation on a bar), when the selected bar's price text updates, or when bars are added/
    // removed. If the widget isn't in the DOM yet, wait for it to be injected, then attach.
    function watchKaching(rootEl) {
      new MutationObserver(recompute).observe(rootEl, {
        attributes: true,
        attributeFilter: ["class"],
        childList: true,
        characterData: true,
        subtree: true,
      });
    }
    var kRoot = kachingRoot();
    if (kRoot) {
      watchKaching(kRoot);
    } else {
      var bodyObs = new MutationObserver(function () {
        var el = kachingRoot();
        if (el) {
          bodyObs.disconnect();
          watchKaching(el);
          recompute();
        }
      });
      bodyObs.observe(document.body, { childList: true, subtree: true });
    }

    recompute();
  }

  // ---- Thumbnail strip: mouse drag-to-scroll -------------------------------------------------
  // The PDP thumbnails are a native horizontal scroll strip (#product-slider-nav). Touch devices
  // swipe it natively, but a mouse can't drag a native-overflow container — so add click-and-drag
  // scrolling for the desktop pointer. Document-delegated so it survives the bundle re-rendering the
  // strip; mouse-only (touch keeps native scroll); a drag past the threshold suppresses the trailing
  // click so it doesn't also switch the main image.
  function initThumbDragScroll() {
    var THRESHOLD = 6;
    var strip = null;
    var startX = 0;
    var startScroll = 0;
    var moved = false;

    document.addEventListener("pointerdown", function (e) {
      if (e.pointerType !== "mouse" || e.button !== 0) return;
      var s = e.target.closest ? e.target.closest("#product-slider-nav") : null;
      if (!s) return;
      strip = s;
      startX = e.clientX;
      startScroll = s.scrollLeft;
      moved = false;
    });
    document.addEventListener("pointermove", function (e) {
      if (!strip) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) < THRESHOLD) return;
      moved = true;
      strip.classList.add("is-dragging");
      strip.scrollLeft = startScroll - dx;
    });
    function end() {
      if (strip) strip.classList.remove("is-dragging");
      strip = null;
    }
    document.addEventListener("pointerup", end);
    document.addEventListener("pointercancel", end);
    // Stop the browser's native image-drag ghost while dragging the strip.
    document.addEventListener("dragstart", function (e) {
      if (strip && e.target.closest && e.target.closest("#product-slider-nav")) e.preventDefault();
    });
    // Swallow the click that ends a drag so it doesn't switch the main image.
    document.addEventListener(
      "click",
      function (e) {
        if (moved && e.target.closest && e.target.closest("#product-slider-nav")) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );
  }

  function init() {
    initPairQty();
    initProfileChartInline();
    initSizeGate();
    initBuyPrice();
    initThumbDragScroll();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
